// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__a0Gtw","empty":"ModalGraph_empty__14y2D"};